import type { UserProfile } from "@/services/authService";
import { isRapidPlan } from "@/utils/accessControl";

export const ROOM_STATUS_SORT_FIELD = "status";

export function shouldShowStatusColumn(
  userProfile: UserProfile | null,
): boolean {
  return !isRapidPlan(userProfile);
}

export function shouldSortBeReset(
  userProfile: UserProfile | null,
  sortField: string | null,
): boolean {
  return (
    sortField === ROOM_STATUS_SORT_FIELD && !shouldShowStatusColumn(userProfile)
  );
}
